import { render } from "./CarouselLoading.vue?vue&type=template&id=044abd52&scoped=true&ts=true"
import script from "./CarouselLoading.vue?vue&type=script&lang=ts"
export * from "./CarouselLoading.vue?vue&type=script&lang=ts"

import "./CarouselLoading.vue?vue&type=style&index=0&id=044abd52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044abd52"]])

export default __exports__